/* unplugin-vue-components disabled */import { render } from "./oauth.vue?vue&type=template&id=c55ec198&scoped=true"
import script from "./oauth.vue?vue&type=script&lang=js"
export * from "./oauth.vue?vue&type=script&lang=js"

import "./oauth.vue?vue&type=style&index=0&id=c55ec198&scoped=true&lang=css"

import exportComponent from "/home/nightdays/app/code/vue/nb-recharge/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c55ec198"]])

export default __exports__